export const BET_TYPES = {
  BET_COURSE: 'betcourse',
  BET_SYSTEM: 'betsystem',
  BET_STRATEGY: 'betstrategy',
}

export const betTypeConfig = {
  betcourse: {
    label: 'BET KURS (STARI)',
    queryKey: 'betKursPoglavlje',
    postPath: '/betcoursechapter',
    getPath: '/betcoursechapters',
    editRoute: '/betko-admin/edituj-post-betkurs',
    createRoute: '/betko-admin/kreiraj-novo-poglavlje-betkurs',
    createPostRoute: '/betko-admin/kreiraj-novi-post-betkurs',
    showChaptersRoute: '/betko-admin/bet-kurs-poglavlja',
    queryKeyPost: 'betKursPosts',
    apiPath: '/betcourse',
    apiPutPath: '/betcourse-post',
    apiPostPath: '/betcourse',
  },
  betsystem: {
    label: 'BET SISTEMI',
    queryKey: 'betSistemPoglavlje',
    postPath: '/betcoursechapter',
    getPath: '/betcoursechapters',
    editRoute: '/betko-admin/edituj-post-betsistem',
    createRoute: '/betko-admin/kreiraj-novo-poglavlje-betsistemi',
    createPostRoute: '/betko-admin/kreiraj-novi-post-betsistemi',
    showChaptersRoute: '/betko-admin/bet-sistemi-poglavlja',
    queryKeyPost: 'betSistemPosts',
    apiPath: '/betcourse',
    apiPutPath: '/betcourse-post',
    apiPostPath: '/betcourse',
  },
  betstrategy: {
    label: 'BET STRATEGIJE',
    queryKey: 'betStrategijePoglavlje',
    postPath: '/betcoursechapter',
    getPath: '/betcoursechapters',
    editRoute: '/betko-admin/edituj-post-betstrategije',
    createRoute: '/betko-admin/kreiraj-novo-poglavlje-betstrategije',
    createPostRoute: '/betko-admin/kreiraj-novi-post-betstrategije',
    showChaptersRoute: '/betko-admin/bet-strategije-poglavlja',
    queryKeyPost: 'betStrategijePosts',
    apiPath: '/betcourse',
    apiPutPath: '/betcourse-post',
    apiPostPath: '/betcourse',
  },
  help: {
    label: 'POMOĆ',
    queryKey: 'pomocSekcija',
    postPath: '/helpsection',
    getPath: '/helpsections',
    editRoute: '/betko-admin/edituj-pomoc-post',
    createRoute: '/betko-admin/kreiraj-novu-pomoc-sekciju',
    createPostRoute: '/betko-admin/kreiraj-novi-pomoc-post',
    showChaptersRoute: '/betko-admin/pomoc-sekcije',
    queryKeyPost: 'helpPosts',
    apiPath: '/helpitems',
    apiPutPath: '/helpitem',
    apiPostPath: '/helpitem',
  },
  calculator: {
    label: 'BET KALKULATORI TUTORIJALI',
    queryKey: 'calculatorTutorijal',
    postPath: '/helpsection',
    getPath: '/helpsections',
    editRoute: '/betko-admin/edituj-kalkulator-tutorijal-post',
    showChaptersRoute: '/betko-admin/vrste-kalkulatora',
    queryKeyPost: 'helpPosts',
    apiPath: '/helpitems',
    apiPutPath: '/helpitem',
    apiPostPath: '/helpitem',
  },
}
